import React, { useState, useEffect } from 'react'
import { Box, Paper, SimpleGrid, Text, TextInput, Textarea,Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  first_name: '',
  last_name: '',
  company: '',
  address_1: '',
  address_2: '',
  city: '',
  city_id: '',
  state: '',
  subdistrict: '',
  postcode: '',
  country: '',
  email: '',
  phone: ''
}

const FormAdjustBillingAndShipping = ({ type, onCloseForm }) => {
  const { general, dropship } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateOrder = async (form) => {
    setLoadingForm(true)
    const payload = {
      order_infos: {
        store_name: dropship.senderName,
        order_number: dropship.orderNo,
        platform: {
          name: dropship.platform.name,
          shipping_courier: dropship.platform.shippingCourier, 
          shipping_document: dropship.platform.shippingDocument,
          tracking_number: dropship.platform.trackingNumber
        },
        billing: type === 'billing' ? form : general.billingInformation,
        shipping: type === 'shipping' ? form : general.shippingInformation
      }
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (general) {
      handleSetForm(general)
    }
    // eslint-disable-next-line
  }, [general])

  const handleSetForm = (data) => {
    if (type === 'billing') {
      setFormData(data.billingInformation)
    } else {
      setFormData(data.shippingInformation)
    }
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Paper shadow="xs" withBorder p="sm" mb='md'>
        <Text fw='Bold' mb={4}>Profile Information</Text>
        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Box>
            <TextInput
              name='first_name'
              value={formData.first_name}
              label='First Name'
              placeholder='Input first name'
              onChange={(val) => handleChangeForm('first_name', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='last_name'
              value={formData.last_name}
              label='Last Name'
              placeholder='Input last name'
              onChange={(val) => handleChangeForm('last_name', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='phone'
              value={formData.phone}
              label='Phone'
              placeholder='Input phone number'
              onChange={(val) => handleChangeForm('phone', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='email'
              value={formData.email}
              label='Email'
              placeholder='Input email'
              onChange={(val) => handleChangeForm('email', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='company'
              value={formData.company}
              label='Company'
              placeholder='Input company'
              onChange={(val) => handleChangeForm('company', val.target.value)}
              size='xs'
            />
          </Box>
        </SimpleGrid>
      </Paper>
      <Paper shadow="xs" withBorder p="sm" mb='md'>
        <Text fw='Bold' mb={4}>Address Information</Text>
        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Box>
            <TextInput
              name='country'
              value={formData.country}
              label='Country'
              placeholder='Input country'
              onChange={(val) => handleChangeForm('country', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='state'
              value={formData.state}
              label='Province'
              placeholder='Input province'
              onChange={(val) => handleChangeForm('state', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='city'
              value={formData.city}
              label='City'
              placeholder='Input city'
              onChange={(val) => handleChangeForm('city', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='subdistrict'
              value={formData.subdistrict}
              label='Subdistrict'
              placeholder='Input subdistrict'
              onChange={(val) => handleChangeForm('subdistrict', val.target.value)}
              size='xs'
            />
          </Box>
          <Box>
            <TextInput
              name='postcode'
              value={formData.postcode}
              label='Postcode'
              placeholder='Input postcode'
              onChange={(val) => handleChangeForm('postcode', val.target.value)}
              size='xs'
            />
          </Box>
        </SimpleGrid>
        <Box mb='sm'>
          <Textarea
            name='address_1'
            label="Street Address"
            placeholder="Input street address"
            value={formData.address_1}
            onChange={(val) => handleChangeForm('address_1', val.target.value)}
            size='xs'
            autosize
            minRows={4}
            maxRows={4}
          />
        </Box>
        <Box mb='sm'>
          <Textarea
            name='address_2'
            label="Street Address 2"
            placeholder="Input street address 2"
            value={formData.address_2}
            onChange={(val) => handleChangeForm('address_2', val.target.value)}
            size='xs'
            autosize
            minRows={4}
            maxRows={4}
          />
        </Box>
      </Paper>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateOrder(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustBillingAndShipping